/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./emailTemplate.vue?vue&type=template&id=2365539f&scoped=true"
import script from "./emailTemplate.vue?vue&type=script&lang=js"
export * from "./emailTemplate.vue?vue&type=script&lang=js"
import style0 from "./emailTemplate.vue?vue&type=style&index=0&id=2365539f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2365539f",
  null
  
)

export default component.exports